import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('/page/index.vue')
const Login = () => import('/page/Login/login.vue')
const Register = () => import('/page/Login/register.vue')
const Home = () => import('/page/Home/home.vue')
const GoodS = () => import('/page/Goods/goods.vue')
const goodsDetails = () => import('/page/Goods/goodsDetails.vue')
const Cart = () => import('/page/Cart/cart.vue')
const order = () => import('/page/Order/order.vue')
const user = () => import('/page/User/user.vue')
const orderList = () => import('/page/User/children/order.vue')
const information = () => import('/page/User/children/information.vue')
const addressList = () => import('/page/User/children/addressList.vue')
const coupon = () => import('/page/User/children/coupon.vue')
const aihuishou = () => import('/page/User/children/aihuishou.vue')
const support = () => import('/page/User/children/support.vue')
const checkout = () => import('/page/Checkout/checkout.vue')
const payment = () => import('/page/Order/payment.vue')
const paysuccess = () => import('/page/Order/paysuccess.vue')
const Thanks = () => import('/page/Thanks/thanks.vue')
const Search = () => import('/page/Search/search.vue')
const RefreshSearch = () => import('/page/Refresh/refreshsearch.vue')
const RefreshGoods = () => import('/page/Refresh/refreshgoods.vue')
const orderDetail = () => import('/page/User/children/orderDetail.vue')
const Alipay = () => import('/page/Order/alipay.vue')
const Wechat = () => import('/page/Order/wechat.vue')
const QQpay = () => import('/page/Order/qqpay.vue')
const Articles = () => import('/page/Articles/articles.vue')
const articlesDetails = () => import('/page/Articles/articleDetails.vue')
const Sites = () => import('/page/Site/sites.vue')
// 商家街
const Merchant = () => import('/page/Merchant/merchant.vue')
const MerchantDetail = () => import('/page/Merchant/merchantDetail.vue')
// 商家入驻
const MerchantApplication = () => import('/page/MerchantApplication/merchantApplication.vue')
// 商城资质
const MerchantCertificate = () => import('/page/MerchantCertificate/merchantcertificate.vue')

//商家管理中心登录
const MerchantLogin = () => import('/page/Merchant/merchantLogin.vue')
// 使用帮助页面
const Help = () => import('/page/Help/help.vue')

// 动态导入帮助页面组件
const HelpPages = {
  help1: () => import('/page/Help/children/help1.vue'), // 会员制度
  help2: () => import('/page/Help/children/help2.vue'), // 积分说明
  help3: () => import('/page/Help/children/help3.vue'), // 交易条款
  help4: () => import('/page/Help/children/help4.vue'), // 购物流程
  help5: () => import('/page/Help/children/help5.vue'), // 订单状态
  help6: () => import('/page/Help/children/help6.vue'), // 购物流程
  help7: () => import('/page/Help/children/help7.vue'), // 购物流程
  help8: () => import('/page/Help/children/help8.vue'), //银行电汇
  help9: () => import('/page/Help/children/help9.vue'), // 余额支付
  help10: () => import('/page/Help/children/help10.vue'), // 支付帮助
  help11: () => import('/page/Help/children/help11.vue'), // 付费咨询
  help12: () => import('/page/Help/children/help12.vue'), //换货说明
  help13: () => import('/page/Help/children/help13.vue'), //退/换货说明
  help14: () => import('/page/Help/children/help14.vue'), //余额的使用与提现
  help15: () => import('/page/Help/children/help15.vue'), //发票制度
  help16: () => import('/page/Help/children/help16.vue'), //售后服务
  help17: () => import('/page/Help/children/help17.vue'), //配送范围及运费
  help18: () => import('/page/Help/children/help18.vue'), //上门自提
  help19: () => import('/page/Help/children/help19.vue'), //加急快递
  help20: () => import('/page/Help/children/help20.vue'), //商品验货与签收
  help21: () => import('/page/Help/children/help21.vue'), //联系客服
  help22: () => import('/page/Help/children/help22.vue'), //关于我们
  help23: () => import('/page/Help/children/help23.vue'), //常见问题
  help24: () => import('/page/Help/children/help24.vue'), //找回密码
  help25: () => import('/page/Help/children/help25.vue'), //退订邮件/短信
  help26: () => import('/page/Help/children/help26.vue'), //用户服务协议
  help27: () => import('/page/Help/children/help27.vue') //隐私条款
};
Vue.use(Router)
export default new Router({
  routes: [{
      path: '/',
      component: Index,
      name: 'index',
      redirect: '/home',
      children: [{
          path: 'home',
          component: Home
        },
        {
          path: 'goods',
          component: GoodS
        },
        {
          path: 'goodsDetails',
          name: 'goodsDetails',
          component: goodsDetails
        },
        {
          path: 'articles',
          component: Articles
        },
        {
          path: 'merchant',
          component: Merchant
        },
        {
          path: 'merchantDetail/:id',
          component: MerchantDetail
        },
        {
          path: 'merchantApplication',
          component: MerchantApplication
        },
        {
          path: 'merchantcertificate',
          component: MerchantCertificate
        },
        {
          path: 'sites',
          component: Sites
        },
        {
          path: '/articlesDetails/:id',
          name: 'articlesDetails',
          component: articlesDetails
        },
        {
          path: 'thanks',
          name: 'thanks',
          component: Thanks
        },
        {
          path: '/refreshgoods',
          name: 'refreshgoods',
          component: RefreshGoods
        },
        //用户协议

      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart
    },
    {
      path: '/refreshsearch',
      name: 'refreshsearch',
      component: RefreshSearch
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      children: [{
          path: 'paysuccess',
          name: 'paysuccess',
          component: paysuccess
        },
        {
          path: 'payment',
          name: 'payment',
          component: payment
        },
        {
          path: '/search',
          name: 'search',
          component: Search
        },
        {
          path: 'alipay',
          name: 'alipay',
          component: Alipay
        },
        {
          path: 'wechat',
          name: 'wechat',
          component: Wechat
        },
        {
          path: 'qqpay',
          name: 'qqpay',
          component: QQpay
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      redirect: '/user/orderList',
      children: [{
          path: 'orderList',
          name: '订单列表',
          component: orderList
        },
        {
          path: 'orderDetail',
          name: '订单详情',
          component: orderDetail
        },
        {
          path: 'information',
          name: '账户资料',
          component: information
        },
        {
          path: 'addressList',
          name: '收货地址',
          component: addressList
        },
        {
          path: 'coupon',
          name: '我的优惠',
          component: coupon
        },
        {
          path: 'support',
          name: '售后服务',
          component: support
        },
        {
          path: 'aihuishou',
          name: '以旧换新',
          component: aihuishou
        }
      ]
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
      redirect: '/help/help1',
      children: [{
          path: 'help1',
          name: '会员制度',
          component: HelpPages.help1
        },
        {
          path: 'help2',
          name: '积分说明',
          component: HelpPages.help2
        },
        {
          path: 'help3',
          name: '交易条款',
          component: HelpPages.help3
        },
        {
          path: 'help4',
          name: '购物流程',
          component: HelpPages.help4
        },
        {
          path: 'help5',
          name: '订单状态',
          component: HelpPages.help5
        },
        {
          path: 'help6',
          name: '货到付款',
          component: HelpPages.help6
        },
        {
          path: 'help7',
          name: '在线支付',
          component: HelpPages.help7
        }, {
          path: 'help8',
          name: '银行电汇',
          component: HelpPages.help8
        },
        {
          path: 'help9',
          name: '余额支付',
          component: HelpPages.help9
        },
        {
          path: 'help10',
          name: '支付帮助',
          component: HelpPages.help10
        },

        {
          path: 'help11',
          name: '付费咨询',
          component: HelpPages.help11
        },
        {
          path: 'help12',
          name: '换货说明',
          component: HelpPages.help12
        },
        {
          path: 'help13',
          name: '退/换货说明',
          component: HelpPages.help13
        },
        {
          path: 'help14',
          name: '余额的使用与提现',
          component: HelpPages.help14
        },
        {
          path: 'help15',
          name: '发票制度',
          component: HelpPages.help15
        }, {
          path: 'help16',
          name: '售后服务',
          component: HelpPages.help16
        },
        {
          path: 'help17',
          name: '配送范围及运费',
          component: HelpPages.help17
        },
        {
          path: 'help18',
          name: '上门自提',
          component: HelpPages.help18
        }, {
          path: 'help19',
          name: '加急快递',
          component: HelpPages.help19
        },
        {
          path: 'help20',
          name: '商品验货与签收',
          component: HelpPages.help20
        },
        {
          path: 'help21',
          name: '联系客服',
          component: HelpPages.help21
        },
        {
          path: 'help22',
          name: '关于我们',
          component: HelpPages.help22
        }, {
          path: 'help23',
          name: '常见问题',
          component: HelpPages.help23
        },
        {
          path: 'help24',
          name: '找回密码',
          component: HelpPages.help24
        },
        {
          path: 'help25',
          name: '退订邮件/短信',
          component: HelpPages.help25
        },
        {
          path: 'help26',
          name: '用户服务协议',
          component: HelpPages.help26
        },
        {
          path: 'help27',
          name: '隐私条款',
          component: HelpPages.help27
        }
      ]
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: checkout
    },
    {
      path: '/merchantLogin',
      name: 'merchantLogin',
      component: MerchantLogin
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js